import { Injectable } from '@angular/core';
import { FirmInformationPage, InvestmentStrategyMainPage, OpenEndFunds, ClosedEndFunds, OtherFunds } from './formdata.models';

@Injectable({
  providedIn: 'root'
})
export class FormData {
  constructor() { }


  firmInformation: FirmInformationPage = new FirmInformationPage();
  investmentStrategyMain: InvestmentStrategyMainPage = new InvestmentStrategyMainPage();
  openEndFunds: OpenEndFunds = new OpenEndFunds();
  closeEndFunds: ClosedEndFunds = new ClosedEndFunds();
  otherFunds: OtherFunds = new OtherFunds();

  constructWebFormPlaceholder() {
    return {
      // id: null,
      // dateCreated: null,
      // dynamoId: null,

      firstName: this.firmInformation.firstName,
      lastName: this.firmInformation.lastName,
      email: this.firmInformation.email,
      phone: this.firmInformation.phone,
      title: this.firmInformation.title,

      marketingFile: this.firmInformation.marketingFile,
      trackRecordFile: this.firmInformation.trackRecordFile,

      firmName: this.firmInformation.firmName,
      streetAddress: this.firmInformation.streetAddress,
      city: this.firmInformation.city,
      country: this.firmInformation.country === 'usa' ? 'United States of America' : this.firmInformation.country,
      yearOfInception: this.firmInformation.yearOfInception,
      firmwideAssetsUnderManagement: this.firmInformation.firmwideAssetsUnderManagement,
      firmwideEmployee: this.firmInformation.firmwideEmployee,
      briefDescription: this.firmInformation.briefDescription,

      fundName: this.investmentStrategyMain.fundName,
      preExistingContact: this.investmentStrategyMain.preExistingContact,
      partnership: this.investmentStrategyMain.partnership,
      fundType: this.investmentStrategyMain.fundType,

      fundStrategy: this.openEndFunds.strategydescription || this.closeEndFunds.strategydescription,

      primarilyTrade: this.openEndFunds.primarilyTrade ? this.openEndFunds.primarilyTrade.join(';') : null,
      geographicFocus: this.openEndFunds.geographicFocus,
      specificSector: this.openEndFunds.specificSector,
      trackRecord: this.openEndFunds.trackRecord,
      annualizedReturn: this.openEndFunds.annualizedReturn,
      annualizedVolatility: this.openEndFunds.annualizedVolatility,
      maximumDrawdown: this.openEndFunds.maximumDrawdown,
      sortinoRatio: this.openEndFunds.sortinoRatio,
      aum: this.openEndFunds.aum,

      closedFundStrategy: this.closeEndFunds.strategyDescription ? this.closeEndFunds.strategyDescription.join(';') : null,
      fundsWithCurrentStrategy: this.closeEndFunds.priorLaunched,
      netIRROfPriorFunds: this.closeEndFunds.irr,
      netMOICOfPreviousFunds: this.closeEndFunds.moic,
      investmentPeriod: this.closeEndFunds.investmentPeriod,
      harvestPeriod: this.closeEndFunds.harvestPeriod,
      targetfundsizemm: this.closeEndFunds.targetFundraise,
      currentAmountOfFundsRaised: this.closeEndFunds.currentAmount,
      finalCloseDate: this.closeEndFunds.finalCloseDate,

      otherStrategyDescription: this.otherFunds.fundDescription,
      doYouHaveAnEstablishedTrackRecord: this.otherFunds.establishedTrackRecord,
      trackRecordDetails: this.otherFunds.trackRecirdDescription,
      haveYouRaisedOutsideCapital: this.otherFunds.raisedOutsideCapital,
      currentCommitments: this.otherFunds.currentlyCommited,
      commitmentDeadlineForFund: this.otherFunds.commitmentDeadline
    };
  }

}
